export default __webpack_public_path__ + "static/media/microsoft-azure-negative.ad60e005.svg";